import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center gap-sm"
}
const _hoisted_3 = { class: "me-2 text-danger" }
const _hoisted_4 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center gap-sm"
}
const _hoisted_5 = { class: "me-2 text-success" }
const _hoisted_6 = { class: "col-sm-12 mt-2" }
const _hoisted_7 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_8 = { class: "text-start p-sm" }
const _hoisted_9 = { class: "text-start p-sm" }
const _hoisted_10 = { class: "text-start p-sm" }
const _hoisted_11 = { class: "p" }
const _hoisted_12 = { class: "p" }
const _hoisted_13 = { class: "p" }
const _hoisted_14 = { class: "p-sm" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  colspan: "3",
  class: "p-sm"
}
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = { class: "p-sm" }
const _hoisted_19 = { class: "d-flex gap-sm" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  colspan: "4",
  class: "p-sm"
}
const _hoisted_23 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_LoaderContent = _resolveComponent("LoaderContent")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    class: "popup__lg",
    title: _ctx.$t('labels.withdrawal_whitelist'),
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LoaderContent, { ref: "loader" }, {
        default: _withCtx(() => [
          (_ctx.account)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!_ctx.account.withdrawalWhitelistsEnabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.helper.trans('labels.whitelists_disabled')), 1),
                      (!_ctx.isMerchantOperator)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.enable()), ["prevent"])),
                            type: "button",
                            class: "btn btn-sm btn-outline-dark"
                          }, _toDisplayString(_ctx.helper.trans('labels.enable')), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.whitelists_enabled')), 1),
                      (!_ctx.isMerchantOperator)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.disable()), ["prevent"])),
                            type: "button",
                            class: "btn btn-sm btn-outline-danger"
                          }, _toDisplayString(_ctx.helper.trans('labels.disable')), 1))
                        : _createCommentVNode("", true)
                    ])),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("table", _hoisted_7, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.address.usdt')), 1),
                        _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.helper.trans('labels.created_at')), 1),
                        _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.helper.trans('labels.deleted_at')), 1),
                        _cache[3] || (_cache[3] = _createElementVNode("th", { class: "p-sm" }, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.withdrawalWhitelists, (item) => {
                        return (_openBlock(), _createElementBlock("tr", null, [
                          _createElementVNode("td", _hoisted_11, _toDisplayString(item.address), 1),
                          _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.dateHelper.format(item.createdAt)), 1),
                          _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.dateHelper.format(item.deletedAt)), 1),
                          _createElementVNode("td", _hoisted_14, [
                            (!item.deletedAt)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.remove(item)),
                                  class: "btn btn-sm"
                                }, [
                                  _createVNode(_component_SvgIcon, { icon: "delete" })
                                ], 8, _hoisted_15))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 256)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newItems, (item) => {
                        return (_openBlock(), _createElementBlock("tr", null, [
                          _createElementVNode("td", _hoisted_16, [
                            _createVNode(_component_FormInputWrapper, {
                              errors: _ctx.getErrors(`${item.id}_address`)
                            }, {
                              default: _withCtx((parentProps) => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: _normalizeClass([parentProps.class, "form-control form-control-sm"]),
                                  "onUpdate:modelValue": ($event: any) => ((item.address) = $event)
                                }, null, 10, _hoisted_17), [
                                  [_vModelText, item.address]
                                ])
                              ]),
                              _: 2
                            }, 1032, ["errors"])
                          ]),
                          _createElementVNode("td", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: ($event: any) => (_ctx.cancel(item)),
                                class: "btn btn-sm"
                              }, [
                                _createVNode(_component_SvgIcon, { icon: "cancel" })
                              ], 8, _hoisted_20),
                              _createElementVNode("button", {
                                type: "button",
                                onClick: ($event: any) => (_ctx.save(item)),
                                class: "btn btn-sm"
                              }, [
                                _createVNode(_component_SvgIcon, { icon: "save" })
                              ], 8, _hoisted_21)
                            ])
                          ])
                        ]))
                      }), 256)),
                      _createElementVNode("tr", null, [
                        (!_ctx.isMerchantOperator)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_22, [
                              _createElementVNode("button", {
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.add()), ["prevent"])),
                                type: "button",
                                class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize-first w-100"
                              }, [
                                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.helper.trans('button.add')), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512),
      _createVNode(_component_ConfirmPopup, { ref: "confirmPopup" }, null, 512)
    ]),
    _: 1
  }, 8, ["title", "onOnClose"]))
}